export default __webpack_public_path__ + "static/media/assembly_5.4567b234.png";